import React from 'react';
import PropTypes from 'prop-types';
import SmallHeading from './SmallHeading';
import { Link } from 'react-router-dom';

const PostCard = ({ heading, link }) => {
  return (
    <div className="w-full rounded-xl border-1 overflow-hidden shadow-md bg-white mx-auto group hover:shadow-lg cursor-pointer">
      <Link
      to={link}
      >
      <SmallHeading name="Blog" tstyle="mt-4 ml-4 md:mt-10 md:ml-10"/>
      <div className="px-6 m-2">
        <div className="font-semibold text-xl mb-4 cursor-pointer">
          {heading}
        </div>
      </div>

      </Link>
    </div>
  );
};

PostCard.propTypes = {
  heading: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default PostCard;
